import { OutlineButton, Tooltip, Callout, Progressbar, EventHandler } from "client/CommonComponents";
import ArrowDown from "client/assets/images/arrowDown.png";
import { useEffect, useState } from "react";
import "./attachments.scss";
import close from "client/assets/images/Close_SuccessPopup.svg";
import attachmentClose from "client/assets/images/Reject.svg"
import { v1 as uuid } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { getFileName } from "utils";
import DragDrop from "./DragDrop";
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";

interface IProps {
  updateAttachments: Function;
  accept?: string;
  link?: any;
  tooltipConent?: any;
  isAttachmentsRequired?:boolean,
  reasonAttachment?:any;
  disabled?: boolean;
}

const Uploader = ({updateAttachments, accept, link, tooltipConent, isAttachmentsRequired,reasonAttachment, disabled = false }: IProps) => {

  const progressPercentage = '40';

  const [visible, setVisible] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const dispatch = useDispatch();
  const { list }: any = useSelector((state: any) => ({
    list: state.UploadAttachmentsReducer.list,
  }));

  useEffect(() => {
    updateAttachments(list);
  }, [list]);

  const dispatchUploadAttachments =
    UploadAttachmentsDispatch.dispatchUploadAttachments(dispatch);
  const dispatchRemoveAttachment =
    UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch);

  const handleAttachmentClick = () => setVisible((prev) => !prev);

  const isUploaded = (name: string) =>
    list.find((x: any) => getFileName(x.attachmentUrl) === name);

  // To upload attachments
  const onUploadClick = (fileList: Array<File>) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    setError("");
    
    const filteredList = [
      ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
    ];
    if (filteredList.length > 0 && filteredList.length <= 5) {
      setError("");
      let totalSize = 0;
      filteredList.forEach((file: File) => {
        totalSize = totalSize + (file.size || 0);
      });
      if (totalSize <= 5000000) {
        setError("");
        const formData = new FormData();
        formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());
        for (let i = 0; i < filteredList.length; i++) {
          formData.append("Files", filteredList[i] as any);
        }
        dispatchUploadAttachments({ formData, filteredList, list });
        setVisible((prev) => !prev);
      } else {
        setError("Please Upload files without exceeding maximum size of 5MB");
      }
    } else if (fileList.length > 5) {
      setError(
        "Please Upload files without exceeding maximum limit of 5 files"
      );
    } else {
      if (fileList.length > 0 && !filteredList.length) {
        setError("files are already uploaded try to add new files");
      } else {
        setError("Choose at least 1 file to upload");
      }
    }
  };
  const onRemove = (index: number) => {
    
     const newArr = list.slice();
    newArr.splice(index, 1);
    dispatchRemoveAttachment(newArr);
  };

  return (
    <div>
      {link ?
        <EventHandler onEvent={handleAttachmentClick} data-attribute="Uploader_Default_EventHandler">
          <span className='title attachment-btn' id="attachments">
            Attachments ({list?.length}) <span className='fa fa-angle-down'></span>
            {isAttachmentsRequired ? <span className='text-danger'>*</span> : null}
          </span>
        </EventHandler>
        :
        <OutlineButton
          text={`Attachments (${+list.length})`}
          className="attachment-btn"
          id="attachments"
         data-attribute="Uploader_Default_Button">
          <EventHandler onEvent={handleAttachmentClick} data-attribute="Uploader_Default_EventHandler_2">
            <img src={ArrowDown} alt="Arrow" title="Arrow down" />
          </EventHandler>
        </OutlineButton>}
      {visible && (
        <Callout
          targetId="attachments"
          toggleIsCalloutVisible={() => setVisible((prev) => !prev)}
          calloutMaxHeight={280}
         data-attribute="Uploader_Default_Callout">
          <div className="upload-header">
            Attachments
            <Tooltip
              content={tooltipConent || "Allowed file formats are jpg, pdf, docx and xlsx. Upload files not more than 5MB. Only 5 files are allowed per Upload."}
             data-attribute="Uploader_Default_Tooltip">
              <span className="fa fa-info-circle attachment-info"></span>
            </Tooltip>
            <EventHandler onEvent={() => setVisible((prev) => !prev)} data-attribute="Uploader_Default_EventHandler_3">
              <img
                src={close}
                alt="close"
                className="close-btn"
              />
            </EventHandler>
          </div>
          <div className="progress-bar mt-2 hide">
            <div className="main-container">
              <div className='upload-text pull-left'>
                <p>Uploading</p>
                <span>{progressPercentage}%- 10 Seconds remaining</span>
              </div>
              <div className="pull-right">
                <img src={attachmentClose} alt='close' className='attachment-close' />
              </div>
            </div>
            <Progressbar progress={progressPercentage}  data-attribute="Uploader_Default_Progressbar" />
          </div>
          <div className="upload-attachments">
            <DragDrop
              multiple
              uploadBtnClick={onUploadClick}
              error={error}
              onRemove={onRemove}
              uploadedList={list}
              accept={accept}
              reasonattchment={reasonAttachment}
              disabled={disabled}
            />
          </div>
        </Callout>
      )}
    </div>
  );
};

export default Uploader;
